import script from "./CustomFiltersItems.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomFiltersItems.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__